const IDENT = /^[A-Za-z_$][A-Za-z0-9_$]*$/;
/** "$.users[0].name" style path; keys that aren't identifiers use ["..."]. */
export function childPath(parent: string, key: string | number): string {
  if (typeof key === "number") return `${parent}[${key}]`;
  return IDENT.test(key) ? `${parent}.${key}` : `${parent}[${JSON.stringify(key)}]`;
}
